import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
// import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Typography, Upload } from "antd";
import {
  ClockIcon,
  EmailIcon,
  PhoneIcon,
  UploadAvatarIcon,
  UserIcon,
} from "assets/icons";
import { PATTERNS } from "constants/appConstant";
import { getIn, useFormik } from "formik";
import parsePhoneNumber from "libphonenumber-js";
import * as moment from "moment-timezone";
import { doUploadAvatar } from "stores/slices/upload";
import {
  doGetUserInfo,
  getUserDetail,
  isSaving,
  updateUserInfo,
} from "stores/slices/user";
// import { YupValidations } from "utils/validation";
import * as Yup from "yup";

import AppButton from "components/button";
import FormInput from "components/forms/components/formInput";
import ModalForm from "components/forms/components/modalForm";

import styles from "../../styles.module.scss";
// const { confirm } = Modal;

const UserProfileForm = props => {
  const { isOpenEdit, setIsOpenEdit } = props;

  const { t } = useTranslation();

  const dispatch = useDispatch();
  // const currentValues = useRef({});

  const userInfo = useSelector(getUserDetail);

  const loading = useSelector(isSaving);

  const [timeZoneList, settimeZoneList] = useState([]);

  const [numberPhoneChange, setChangeValueNumber] = useState();

  const [avatar, setAvatar] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  const inputItems = [
    {
      type: "text",
      key: "firstName",
      label: t("label.firstName"),
      placeholder: "label.firstName",
      icon: <UserIcon />,
      span: 24,
      colon: true,
      style: {
        marginBottom: 16,
      },
    },
    {
      type: "text",
      key: "lastName",
      label: t("label.lastName"),
      placeholder: "label.lastName",
      icon: <UserIcon />,
      span: 24,
      colon: true,
      style: {
        marginBottom: 16,
      },
    },
    {
      type: "string",
      key: "phoneNumber",
      label: t("label.userPhoneNumber"),
      placeholder: "text.userPhoneNumber",
      icon: <PhoneIcon />,
      span: 24,
      colon: true,
      style: {
        marginBottom: 16,
        width: "100%",
      },
      required: true,
      config: {
        controls: false,
        size: "large",
        style: {
          width: "100%",
        },
      },
    },
    {
      type: "text",
      key: "email",
      label: t("label.emailAddress"),
      placeholder: "label.emailAddress",
      icon: <EmailIcon />,
      span: 24,
      colon: true,
      style: {
        marginBottom: 16,
      },
      disabled: true,
    },
    {
      type: "select-search",
      key: "timeZone",
      label: t("label.timezone"),
      placeholder: "label.timezone",
      options: timeZoneList,
      icon: <ClockIcon />,
      span: 24,
      colon: true,
      style: {
        marginBottom: 16,
      },
      noAllowClear: true,
    },
  ];

  useEffect(() => {
    console.log("====================================");
    console.log("numberPhoneChange", numberPhoneChange);
    console.log("====================================");
    if (numberPhoneChange) {
      setFieldValue("phoneNumber", numberPhoneChange);
    }
  }, [numberPhoneChange]);

  const validationSchema = Yup.object().shape({
    firstName: Yup.string()
      .trim()
      .matches(PATTERNS.XSS_PATTERN, "validate.noxss")
      .max(255, "validate.max_length_255"),
    lastName: Yup.string()
      .trim()
      .matches(PATTERNS.XSS_PATTERN, "validate.noxss")
      .max(255, "validate.max_length_255"),
    phoneNumber: Yup.string()
      .trim()
      .required("validate.required")
      .test("phoneNumber", "validate.phoneNumber.invalid", value => {
        let phoneNumber = value;

        if (
          PATTERNS.PHONE_NUMBER_LENGTH.test(value) &&
          PATTERNS.ZERO_ONLY.test(value)
        ) {
          const validPhoneNumber = parsePhoneNumber(phoneNumber);
          console.log("====================================");
          console.log("validPhoneNumber", validPhoneNumber);
          console.log("====================================");
          if (validPhoneNumber && validPhoneNumber.isPossible()) {
            if (validPhoneNumber.country && validPhoneNumber.isValid()) {
              const newValue = validPhoneNumber.formatInternational();
              setChangeValueNumber(
                newValue.toString().replaceAll(" ", "").replaceAll("+", "")
              );
              return true;
            }
          } else {
            phoneNumber = value.includes("+") ? value : `+${phoneNumber}`;
            const validContactNumber = parsePhoneNumber(phoneNumber);

            if (validContactNumber && validContactNumber.isPossible()) {
              if (validContactNumber.country && validContactNumber.isValid()) {
                const newValue = validContactNumber.formatInternational();
                setChangeValueNumber(
                  newValue.toString().replaceAll(" ", "").replaceAll("+", "")
                );
                return true;
              } else {
                setChangeValueNumber(value);
                return false;
              }
            } else {
              const validPhoneNumber2 = parsePhoneNumber(value, "AU");
              if (validPhoneNumber2 && validPhoneNumber2.isPossible()) {
                if (validPhoneNumber2.country && validPhoneNumber2.isValid()) {
                  const newValue = validPhoneNumber2.formatInternational();
                  setChangeValueNumber(
                    newValue.toString().replaceAll(" ", "").replaceAll("+", "")
                  );
                  return true;
                } else {
                  setChangeValueNumber(value);
                  return false;
                }
              } else {
                const validContactNumber2 = parsePhoneNumber(phoneNumber, "AU");
                if (validContactNumber2 && validContactNumber2.isPossible()) {
                  if (
                    validContactNumber2.country &&
                    validContactNumber2.isValid()
                  ) {
                    const newValue = validContactNumber2.formatInternational();
                    setChangeValueNumber(
                      newValue
                        .toString()
                        .replaceAll(" ", "")
                        .replaceAll("+", "")
                    );
                    return true;
                  } else {
                    setChangeValueNumber(value);
                    return false;
                  }
                }
              }
            }
          }
        } else {
          console.log("====================================");
          console.log("value", value);
          console.log("====================================");
          setChangeValueNumber(value);
          return false;
        }
      })
      .matches(PATTERNS.PHONE_NUMBER_LENGTH, {
        message: "validate.phoneNumber.invalid",
      })
      .min(6, "validate.min_length_6")
      .max(20, "validate.max_length_20"),
  });

  const onSubmit = async data => {
    const request = {
      profileImage: avatar,
      firstName: data?.firstName,
      lastName: data?.lastName,
      timeZone: data?.timeZone,
      phoneNumber: data?.phoneNumber,
    };
    if (userInfo && userInfo.id) {
      const { payload } = await dispatch(
        updateUserInfo({ ...request, id: userInfo.id })
      );
      if (payload && payload.status === 200) {
        dispatch(doGetUserInfo(payload.data.id));
        setIsOpenEdit(false);
      }
    }
  };

  const handleForm = useFormik({
    initialValues: {
      profileImage: avatar || "",
      firstName: userInfo?.firstName || "",
      lastName: userInfo?.lastName || "",
      phoneNumber: userInfo?.phoneNumber || "",
      email: userInfo?.email || "",
      timeZone: userInfo?.timeZone || "",
    },
    validationSchema: validationSchema,
    onSubmit: onSubmit,
  });

  const { values, setFieldValue, handleSubmit, setValues, handleReset } =
    handleForm;

  // const confirmUnSave = async () => {
  //   await confirm({
  //     title: t("user.userProfile.unsavedChange"),
  //     icon: <ExclamationCircleOutlined />,
  //     content: t("user.userProfile.unsavedChangeMsg"),
  //     okText: t("button.save"),
  //     cancelText: t("button.cancel"),
  //     onOk: async () => {
  //       await handleSubmit();
  //       handleReset();
  //       setIsOpenEdit(false);
  //     },
  //     onCancel() {
  //       handleReset();
  //       setIsOpenEdit(false);
  //     },
  //   });
  // };

  // const handleConfirmUnSave = () => {
  //   if (
  //     JSON.stringify(currentValues?.current) !== JSON.stringify(values) ||
  //     JSON.stringify(currentValues?.current?.profileImage) !==
  //       JSON.stringify(avatar)
  //   ) {
  //     confirmUnSave();
  //   } else {
  //     setIsOpenEdit(false);
  //   }
  // };

  const beforeUploadImg = async file => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      toast.error("You can only upload JPG/JPEG/PNG file!");
      console.log("You can only upload JPG/PNG file!");
    }
    const isLt2M = file.size / 1024 / 1024 < 5;
    if (!isLt2M) {
      toast.error("Image must smaller than 5MB!");
      console.log("Image must smaller than 5MB!");
    }
    return isJpgOrPng && isLt2M;
  };

  const handleUploadImg = async info => {
    setIsUploading(true);
    const request = {
      cannedAccessControlList: "PublicRead",
      uploadFileType: "UPLOAD_AVATAR",
      file: info.file,
    };
    const result = await dispatch(doUploadAvatar(request));
    if (result && result.payload.status === 200) {
      setAvatar(result.payload.data);
    }
    setIsUploading(false);
  };

  useEffect(() => {
    const list = moment.tz.names().map(item => {
      return {
        id: item,
        name: item,
      };
    });

    settimeZoneList(list);
  }, []);

  useEffect(() => {
    if (isOpenEdit && userInfo) {
      handleReset();
      const values = {
        firstName: userInfo?.firstName || "",
        lastName: userInfo?.lastName || "",
        phoneNumber: userInfo?.phoneNumber || "",
        address: userInfo?.address || "",
        email: userInfo?.email || "",
        timeZone: userInfo?.timeZone || "",
      };
      setValues(values);
      // currentValues.current = values;
    }
  }, [isOpenEdit, userInfo]);

  return (
    <ModalForm
      title={t("title.updateUserProfile")}
      onCancel={() => {
        setIsOpenEdit(false);
        handleReset();
        // confirmUnSave();
      }}
      isOpen={isOpenEdit}
      labelSubmit={t("label.save")}
      customWidth={700}
      footer={false}
      maskClosable={false}
    >
      <div style={{ height: "100%" }}>
        <Typography.Text>{t("user.profileImage")}</Typography.Text>
        <Upload
          name="avatar"
          listType="picture-card"
          className="avatar-uploader"
          showUploadList={false}
          multiple={true}
          beforeUpload={beforeUploadImg}
          customRequest={handleUploadImg}
          accept={".png, .jpg, .jpeg"}
        >
          {isUploading ? (
            <div>
              <div className={styles.profileFormContainer}>
                <div className={styles.uploadAvatarIcon}>
                  <UploadAvatarIcon />
                </div>
              </div>
              <Typography
                style={{
                  marginTop: 8,
                  color: "#626576",
                }}
              >
                {"Uploading..."}
              </Typography>
            </div>
          ) : avatar || (userInfo && userInfo.profileImage) ? (
            <div
              style={{
                width: "100%",
                maxHeight: "100px",
              }}
            >
              <img
                src={
                  avatar
                    ? avatar
                    : userInfo && userInfo.profileImage
                    ? userInfo.profileImage
                    : avatar
                }
                alt="avatar"
                style={{ width: "90px", height: "90px", objectFit: "cover" }}
              />
            </div>
          ) : (
            !isUploading && (
              <div>
                <div className={styles.uploadContainer}>
                  <div className={styles.uploadAvatarIcon}>
                    <UploadAvatarIcon />
                  </div>
                </div>
                <Typography
                  style={{
                    marginTop: 8,
                    color: "#626576",
                  }}
                >
                  {t("text.uploadAvatarMsg")}
                </Typography>
              </div>
            )
          )}
        </Upload>
        <FormInput
          items={inputItems.map(item => {
            item.label = t(item.label);
            if (item.key) {
              item.value = getIn(values, item.key);
            }
            return { ...item };
          })}
          form={handleForm}
          onChange={setFieldValue}
          layout={"vertical"}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "end",
          }}
        >
          <AppButton
            label={t("label.cancel")}
            color={"grey"}
            loading={loading}
            type="button"
            onClick={() => {
              setIsOpenEdit(false);
              // setValues(userInfo ? userInfo : handleForm.initialValues);
              handleReset();
              // handleConfirmUnSave();
            }}
            size={"minimum"}
            className={"cancelButton"}
          />
          <AppButton
            label={t("label.save")}
            color={"blue"}
            loading={loading}
            type="submit"
            onClick={handleSubmit}
            size={"minimum"}
          />
        </div>
      </div>
    </ModalForm>
  );
};

export default UserProfileForm;
